import { create } from 'zustand';

export type TabId = 'home' | 'challenges' | 'feed' | 'profile';

interface TabState {
  activeTab: TabId;
  setActiveTab: (tab: TabId) => void;
}

export const useTabStore = create<TabState>()((set) => ({
  activeTab: 'home',
  setActiveTab: (tab) => set({ activeTab: tab }),
}));
